"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.hygzChart = exports.gggzChart = exports.scgzChart = exports.dateFormate2 = void 0;
/**
 * 公用方法
 */
var webconfig = require('../../config/web');
var utils_1 = __importDefault(require("../../src/modules/commonutil/utils"));
require("emdataview");
var zsObj = {
    "000300": "沪深300",
    "000001": "上证指数",
    "000688": "科创50",
    "399001": "深证指数",
    "399006": "创业板指",
    "899050": "北证50指"
};
var dateFormate2 = function (dateS, part) {
    if (dateS == "-" || typeof dateS == "undefined") {
        return '-';
    }
    if (dateS.length > 10) {
        dateS = dateS.split('T')[0].replace(/-/g, "/");
    }
    var date = new Date(dateS);
    var datecopy;
    var redate = "";
    part = (part == null) ? "yyyy-MM-dd HH:mm:ss" : part;
    var y = date.getFullYear();
    var M = date.getMonth() + 1;
    var d = date.getDate();
    var H = date.getHours();
    var m = date.getMinutes();
    var s = date.getSeconds();
    var MM = (M > 9) ? M : "0" + M;
    var dd = (d > 9) ? d : "0" + d;
    var HH = (H > 9) ? H : "0" + H;
    var mm = (m > 9) ? m : "0" + m;
    var ss = (s > 9) ? s : "0" + s;
    redate = part.replace("yyyy", y).replace("MM", MM).replace("dd", dd).replace("HH", HH).replace("mm", mm).replace("ss", ss).replace("M", M).replace("d", d).replace("H", H).replace("m", m).replace("s", s);
    return redate;
};
exports.dateFormate2 = dateFormate2;
var scgzChart = {
    XData: [],
    YData: [],
    init: function () {
        var that = this;
        this.line_chart = echarts.init(document.getElementById('scgz_chart'));
        var mydate = new Date();
        var sdate = mydate.setFullYear(mydate.getFullYear() - 2);
        this.sdate = dateFormate2(sdate, 'yyyy-MM-dd');
        this.loadData();
        $('#scgz_chart_radio input').change(function () {
            var type = $(this).data('type') || '';
            var name = $(this).next("label").text();
            that.loadData(type, name) || '';
        });
    },
    loadData: function (type, name) {
        var that = this;
        that.line_chart.showLoading({
            text: '图表加载中...' //loading
        });
        type = type || '000300';
        name = name || '两市平均市盈率';
        that.XData = [];
        that.YData = [];
        that.ZS = [];
        $.ajax({
            url: webconfig.getWebPath('datacenter') + "api/data/v1/get",
            type: 'get',
            dataType: 'jsonp',
            data: {
                reportName: "RPT_VALUEMARKET",
                columns: "ALL",
                quoteColumns: "",
                pageNumber: 1,
                sortColumns: "TRADE_DATE",
                sortTypes: 1,
                source: "WEB",
                client: "WEB",
                filter: "(TRADE_MARKET_CODE=\"" + type + "\")(TRADE_DATE>'" + that.sdate + "')"
            }
        }).then(function (json) {
            var _a;
            var data = (_a = json === null || json === void 0 ? void 0 : json.result) === null || _a === void 0 ? void 0 : _a.data;
            for (var i = 0; i < data.length; i++) {
                var item = data[i];
                that.XData.push(dateFormate2(item.TRADE_DATE, 'yyyy-MM-dd'));
                that.YData.push(utils_1["default"].toFixed2(item.PE_TTM_AVG));
                that.ZS.push(utils_1["default"].toFixed2(item.CLOSE_PRICE));
            }
            that.drawChart(type, name);
        }).fail(function (err) {
            console.log(err);
        });
    },
    drawChart: function (type, name) {
        var that = this;
        var option = {
            title: {
                text: "市场估值走势图",
                left: 'center'
            },
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                right: 20,
                selectedMode: false
            },
            grid: {
                x: '6%',
                y: '15%',
                width: '88%',
                height: '75%',
            },
            xAxis: {
                type: 'category',
                data: that.XData,
                axisLine: {
                    lineStyle: {
                        color: '#4488BB',
                        width: 2
                    }
                },
                axisTick: { show: false },
                splitLine: {
                    show: false
                },
                axisLabel: {
                    textStyle: {
                        color: '#000'
                    }
                }
            },
            yAxis: [
                {
                    type: 'value',
                    scale: true,
                    //name: '单位：' + danwei,
                    nameTextStyle: {
                        color: '#000'
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#4488BB',
                            width: 2
                        }
                    },
                    axisTick: { show: false },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dotted',
                            color: "#E6E6E6"
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#000'
                        }
                    },
                },
                {
                    type: 'value',
                    scale: true,
                    axisLine: {
                        lineStyle: {
                            color: '#4488BB',
                            width: 2
                        }
                    },
                    axisTick: { show: false },
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#000'
                        }
                    },
                }
            ],
            series: [
                {
                    name: name + "(左)",
                    data: that.YData,
                    connectNulls: true,
                    symbol: "circle",
                    showSymbol: false,
                    itemStyle: {
                        color: '#2fade6',
                        normal: {
                            color: '#2fade6',
                            borderColor: "#2fade6"
                        }
                    },
                    type: 'line'
                },
                {
                    name: zsObj[type] + "(右)" || "指数",
                    data: that.ZS,
                    yAxisIndex: 1,
                    connectNulls: true,
                    symbol: "circle",
                    showSymbol: false,
                    itemStyle: {
                        color: '#E04527',
                        normal: {
                            color: '#E04527',
                            borderColor: "#E04527"
                        }
                    },
                    type: 'line'
                }
            ]
        };
        that.line_chart.setOption(option);
        that.line_chart.hideLoading();
    }
};
exports.scgzChart = scgzChart;
var gggzChart = {
    XData: [],
    YData: [],
    init: function (gzDate, type, name) {
        if (type === void 0) { type = 'PE_TTM'; }
        if (name === void 0) { name = 'PE(TTM)'; }
        var that = this;
        this.chart_bar = echarts.init(document.getElementById('gggz_chart'));
        this.chart_bar.clear();
        this.loadData(gzDate, type, name);
    },
    loadData: function (gzDate, type, name) {
        var that = this;
        that.chart_bar.showLoading({
            text: '图表加载中...' //loading
        });
        that.XData = [];
        that.YData = [];
        var num = 2; //保留小数位
        $.ajax({
            url: webconfig.getWebPath('datacenter') + "api/data/v1/get",
            type: 'get',
            dataType: 'jsonp',
            data: {
                reportName: "RPT_VALUEANALYSIS_DET",
                columns: "SECURITY_CODE,TRADE_DATE,SECURITY_NAME_ABBR," + type,
                quoteColumns: "",
                pageNumber: 1,
                pageSize: 10,
                sortColumns: type,
                sortTypes: 1,
                source: "WEB",
                client: "WEB",
                filter: "(TRADE_DATE='" + gzDate + "')(" + type + ">0)"
            }
        }).then(function (json) {
            var _a;
            var data = (_a = json === null || json === void 0 ? void 0 : json.result) === null || _a === void 0 ? void 0 : _a.data;
            for (var i = 0; i < data.length; i++) {
                var item = data[i];
                that.XData.push(item.SECURITY_NAME_ABBR);
                if (type === 'PEG_CAR') {
                    num = 4;
                    item[type] = parseFloat(item[type]) * 1e4;
                }
                that.YData.push(utils_1["default"].toFixed2(item[type], num));
            }
            that.drawChart(type, name);
        }).fail(function (err) {
            console.log(err);
        });
    },
    drawChart: function (type, name) {
        var that = this;
        var yAxisName = type === 'PEG_CAR' ? "单位:(*0.0001)" : "";
        var option = {
            title: {
                text: "沪深" + name + "排名前十个股",
                left: 'center'
            },
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                right: 20,
                selectedMode: false
            },
            grid: {
                x: '8%',
                y: '15%',
                width: '84%',
                height: '75%'
            },
            xAxis: {
                type: 'category',
                data: that.XData,
                axisLine: {
                    lineStyle: {
                        color: '#4488BB',
                        width: 2
                    }
                },
                axisTick: { show: false },
                splitLine: {
                    show: false
                },
                axisLabel: {
                    textStyle: {
                        color: '#000'
                    }
                }
            },
            yAxis: [
                {
                    name: yAxisName,
                    type: 'value',
                    scale: true,
                    nameTextStyle: {
                        color: '#000'
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#4488BB',
                            width: 2
                        }
                    },
                    axisTick: { show: false },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dotted',
                            color: "#E6E6E6"
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#000'
                        }
                    }
                }
            ],
            series: [
                {
                    name: name,
                    type: 'bar',
                    itemStyle: {
                        color: '#2F5895'
                    },
                    data: that.YData
                }
            ]
        };
        that.chart_bar.setOption(option);
        that.chart_bar.hideLoading();
    }
};
exports.gggzChart = gggzChart;
var hygzChart = {
    init: function (gzDate, type, name) {
        if (type === void 0) { type = "PE_TTM"; }
        if (name === void 0) { name = "PE(TTM)"; }
        var that = this;
        this.chart_bar = echarts.init(document.getElementById('hygz_chart'));
        that.type = type;
        that.name = name;
        that.isMuch = that.type === "MARKET_CAP_VAG";
        this.loadData(gzDate);
    },
    loadData: function (gzDate) {
        var that = this;
        that.chart_bar.showLoading({
            text: '图表加载中...' //loading
        });
        that.XData = [];
        that.YData = [];
        var srStr = that.isMuch ? "-1" : "1";
        $.ajax({
            url: webconfig.getWebPath('datacenter') + "api/data/v1/get",
            type: 'get',
            dataType: 'jsonp',
            data: {
                reportName: "RPT_VALUEINDUSTRY_DET",
                columns: "ALL",
                quoteColumns: "",
                pageNumber: 1,
                sortColumns: that.type,
                sortTypes: srStr,
                source: "WEB",
                client: "WEB",
                filter: "(TRADE_DATE='" + gzDate + "')(" + that.type + ">0)"
            }
        }).then(function (json) {
            var _a;
            var data = (_a = json === null || json === void 0 ? void 0 : json.result) === null || _a === void 0 ? void 0 : _a.data;
            for (var i = 0; i < data.length; i++) {
                var item = data[i];
                that.XData.push(item.BOARD_NAME);
                if (that.isMuch) {
                    that.YData.push(utils_1["default"].toFixed2(parseFloat(item[that.type]) / 1e8));
                }
                else {
                    that.YData.push(utils_1["default"].toFixed2(item[that.type]));
                }
            }
            that.drawChart();
        }).fail(function (err) {
            console.log(err);
        });
    },
    drawChart: function () {
        var that = this;
        var option = {
            title: {
                text: "行业" + that.name + "排名",
                left: '5%'
            },
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                right: 20,
                selectedMode: false
            },
            grid: {
                x: '5%',
                y: '15%',
                width: '90%',
                height: '60%'
            },
            xAxis: {
                type: 'category',
                data: that.XData,
                axisLine: {
                    lineStyle: {
                        color: '#4488BB',
                        width: 2
                    }
                },
                axisTick: { show: false },
                splitLine: {
                    show: false
                },
                axisLabel: {
                    interval: 0,
                    textStyle: {
                        color: '#000'
                    },
                    formatter: function (value) {
                        var str = value.split("");
                        return str.join("\n");
                    }
                }
            },
            yAxis: [
                {
                    type: 'value',
                    scale: true,
                    nameTextStyle: {
                        color: '#000'
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#4488BB',
                            width: 2
                        }
                    },
                    axisTick: { show: false },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dotted',
                            color: "#E6E6E6"
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#000'
                        }
                    }
                }
            ],
            series: [
                {
                    name: that.name,
                    type: 'bar',
                    itemStyle: {
                        color: '#2F5895'
                    },
                    data: that.YData
                }
            ]
        };
        that.chart_bar.setOption(option);
        that.chart_bar.hideLoading();
    }
};
exports.hygzChart = hygzChart;
